import React from 'react';
import Dokument from '../layout/Dokument';

export default function Documents() {
  return (
    <div>
      <Dokument />
    </div>
  );
}
